import styled from 'styled-components'

export const ProfileIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;  
`

export const ProfileIconImage = styled.div`
  height: ${(props) => {
    return props.height || '40px'
  }};
  width: ${(props) => {
    return props.width || '40px'
  }};
  background: #92BF00;
  border-radius: 50%;  
  position: relative; 
  text-align: center;

  > p {
    position: absolute;           
    width: 100%;    
    font-weight: 700;
    font-size: 12px;
    line-height: 16px; 
    color: white;    
  }
`

export const ProfileIconNameWrapper = styled.div`  
  display: block;  
  margin-left: 24px;  
`

export const ProfileIconName = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: black;
  margin-bottom: 0;
`

export const ProfileIconRole = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: rgba(32, 32, 32, 0.7);
  margin-top: 0;
  
`
